import { combineReducers } from "redux";
import projectReducer from "./projectReducer";
import equipmentReducer from "./equipmentReducer";
import userReducer from "./userReducer";
import surveyReducer from "./surveyReducer";
import taskReducer from "./taskReducer";
import loginReducer from "./loginReducer";
import selectProjectReducer from "./selectProjectReducer";
import projectRoleReducer from "./projectRoleReducer";
import materialReducer from "./materialReducer";
import locationReducer from "./locationReducer";
import serviceFirmReducer from "./serviceFirmReducer";
import checklistReducer from "./checklistReducer";
import supportReducer from "./supportReducer";
import poolReducer from "./poolReducer";
import qrcodeReducer from "./qrcodeReducer";
import equipmentTreesReducer from "./equipmentTreesReducer";
import jobReducer from "./jobReducer";
import photosReducer from "./photosReducer";
import notificationReducer from "./notificationReducer";
import documentReducer from "./documentReducer";
import dashboardReducer from "./dashboardReducer";
import pageReducer from "./pageReducer";
import rolesReducer from "./rolesReducer";
import rolePagesReducer from "./rolePagesReducer";
import warehouseReducer from "./warehouseReducer";
import tenantReducer from "./tenantReducer";
import customerReducer from "./customerReducer";
import contactReducer from "./contactReducer";
import contractReducer from "./contractReducer";
import crmInvoiceReducer from "./crmInvoiceReducer";
import leadsReducer from "./leadsReducer";
import createTypeReducer from "./createTypeReducer";
import merchantReducer from "./merchantReducer";
import commissionReducer from "./commissionReducer";
import merchantAndTransactionReducer from "./merchantAndTransactionReducer";
import transactionReducer from "./transactionReducer";
import EndUserBankCardReducer from "./EndUserBankCardReducer";
import BankReducer from "./bankReducer";
import errorReducer from "./errorReducer";
import formReducer from "./formReducer";
import binReducer from "./binReducer";
import kioskReducer from "./kioskReducer";
import authorizeReducer from "./authorizeReducer";
import binProfilPaymentReducer from "./binProfilPaymentReducer";
import profilesReducer from "./profilesReducer";

export default combineReducers({
  projectReducer: projectReducer,
  equipmentReducer: equipmentReducer,
  userReducer: userReducer,
  surveyReducer: surveyReducer,
  taskReducer: taskReducer,
  loginReducer: loginReducer,
  selectProjectReducer: selectProjectReducer,
  projectRoleReducer: projectRoleReducer,
  materialReducer: materialReducer,
  locationReducer: locationReducer,
  serviceFirmReducer: serviceFirmReducer,
  checklistReducer: checklistReducer,
  supportReducer: supportReducer,
  poolReducer: poolReducer,
  qrcodeReducer: qrcodeReducer,
  equipmentTreesReducer: equipmentTreesReducer,
  jobReducer: jobReducer,
  notificationReducer: notificationReducer,
  photosReducer: photosReducer,
  documentReducer: documentReducer,
  dashboard: dashboardReducer,
  pages: pageReducer,
  roles: rolesReducer,
  rolePages: rolePagesReducer,
  warehouses: warehouseReducer,
  tenantReducer: tenantReducer,
  customers: customerReducer,
  contactReducer: contactReducer,
  crmInvoiceReducer: crmInvoiceReducer,
  leadsReducer: leadsReducer,
  createTypeReducer: createTypeReducer,
  contractReducer: contractReducer,
  merchantReducer: merchantReducer,
  commissionReducer: commissionReducer,
  merchantAndTransactionReducer: merchantAndTransactionReducer,
  transactionReducer: transactionReducer,
  EndUserBankCardReducer: EndUserBankCardReducer,
  BankReducer: BankReducer,
  errorReducer: errorReducer,
  formReducer: formReducer,
  binReducer: binReducer,
  kioskReducer: kioskReducer,
  authorize: authorizeReducer,
  binProfilPaymentReducer: binProfilPaymentReducer,
  profilesReducer: profilesReducer,
});
